import { connect } from 'react-redux';
import clone from 'lodash/cloneDeep';
import View from './ChildrenOverviewView';
import { currentClientId, data2, isGoingForwardSelector } from '../../AdvWorkflow/AdvWorkflowSelector';
import childrenSelector, { isEmptyStateSelector, viewIDSelector } from './ChildrenOverviewSelector';
import { updateData, updateSupportData } from '../../AdvWorkflow/AdvWorkflowActions';
import {
  BACKEND_KEY,
  DEFAULT_CHILD,
  CHILDREN_CRUD_ADD_EDIT,
} from '../PersonalInfoWorkflowConstants';

const mapStateToProps = (state, ownProps) => ({
  clientId: currentClientId(state, ownProps),
  hasChildren: data2(state, ownProps)(`${BACKEND_KEY}.HasChildren`),
  children: childrenSelector(state, ownProps),
  alreadyHadChildrenData: data2(state, ownProps)(`${BACKEND_KEY}.AlreadyHadChildrenData`),
  isEmptyState: isEmptyStateSelector(state, ownProps),
  viewID: viewIDSelector(state, ownProps),
  isGoingForward: isGoingForwardSelector(state, ownProps),
});
const mapDispatchToProps = dispatch => ({
  onPostSave: (store2, clientId) => (data) => {
    store2(
      {
        [BACKEND_KEY]: {
          HasChildren: data.PersonalInfo.Dependents && data.PersonalInfo.Dependents.length !== 0,
        },
      },
      clientId,
    );
  },
  onRemoveChild: (children, store, index, clientId) => (event) => {
    event.preventDefault();
    event.stopPropagation();
    store(
      {
        [BACKEND_KEY]: {
          Dependents: [...children.slice(0, index), ...children.slice(index + 1)],
        },
      },
      clientId,
    );
  },
  onAddChild: (children, store, store2, clientId) => (event) => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    store(
      {
        [BACKEND_KEY]: {
          Dependents: [...children, clone(DEFAULT_CHILD)],
        },
      },
      clientId,
    );
    store2(
      {
        [BACKEND_KEY]: {
          ChildrenStepViewID: CHILDREN_CRUD_ADD_EDIT,
          ChildrenStepIndex: children.length,
          ChildrenStepIsEdit: false,
        },
      },
      clientId,
    );
  },
  onEditChild: (children, store, store2, index, clientId) => (event) => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    store2(
      {
        [BACKEND_KEY]: {
          ChildrenStepViewID: CHILDREN_CRUD_ADD_EDIT,
          ChildrenStepIndex: index,
          ChildrenStepIsEdit: true,
        },
      },
      clientId,
    );
  },
  childInputChanged: (children, store, index, fieldName, clientId) => (event) => {
    store(
      {
        [BACKEND_KEY]: {
          Dependents: [
            ...children.slice(0, index),
            {
              ...children[index],
              [fieldName]: event.target.value,
            },
            ...children.slice(index + 1),
          ],
        },
      },
      clientId,
    );
  },
  store: workflowId => (data, clientId) => dispatch(updateData(data, workflowId, clientId)),
  store2: workflowId => (data, clientId) => dispatch(updateSupportData(data, workflowId, clientId)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(View);
